const interviewsArray = [
  <>
    <p>Interview #2</p>
    <p>
      The strangest part about all of this is that there is nothing really
      stopping me from doing it.
    </p>
    <p>Q</p>
    <p>
      It’s entirely possible for me to just make a group chat on my phone with
      all the people I love and have them all together in a single group where
      they can all meet and talk to one another.
    </p>
    <p>Q</p>
    <p>
      You know, friends from high school, friends from college, my sister, my
      old roommate, just all the people who matter to me. The people who are
      most important to me. All in one group chat. It could be so nice.
    </p>
    <p>Q</p>
    <p>
      People complain about lack of connectivity because of technology. But
      look, there is nothing physically stopping me from just creating a group
      message after I’m done talking to you and making a group chat.
    </p>
    <p>Q</p>
    <p>And that’s terrifying. At least to me.</p>
    <p>Q</p>
    <p>
      I mean how cool would it be if my best friend from college and my friend
      from that semester I spent in Denmark were to meet. They would get along,
      they have a lot in common, they will make one another better. And then I
      can add another friend, who knows, maybe my roommate? Someone else. And
      they can talk, these people who are important to me. And build a
      relationship.
    </p>
    <p>Q</p>
    <p>
      But this possibility relies on me. Because they won’t otherwise. I am that
      connective tissue.
    </p>
    <p>Q</p>
    <p>
      I suppose we all do live in our own little bubbles, our little groups. But
      the internet makes it possible to pop those bubbles. Nobody pops the
      bubbles. It is possible that other people do this. Introducing strangers
      with the mutual connection being you. But I don’t know anyone who does do
      this. Which is even more unnerving. Like…I don’t think anyone even thinks
      about it.
    </p>
    <p>Q</p>
    <p>Right? It’s so frustrating.</p>
    <p>Q</p>

    <p>
      How cool would it be if I sat down and wrote out a text saying, “hey you
      are all important people to me, I just thought it would be cool if we had
      a little group chat of my favorite people”? And then I add a cute little
      heart emoji. But that would never happen.
    </p>
    <p>Q</p>
    <p>
      Because I fear people would think that’s weird. It’s the horrifying
      reality of technology. There are people out there who would never
      naturally meet…but they can. They can easily. Just a little bit of work in
      my phone. So maybe, my fear comes from an internal belief that some lives
      are simply not meant to interact in their lifetimes.
    </p>
    <p>Q</p>
    <p>Almost as if I am disrupting the normal social balance of things.</p>
    <p>Q</p>
    <p>
      I don’t want to be hyperbolic or anything, but if I were about to send out
      that messages to all my close people, and my thumb is about to press
      “send” I feel like I will somehow deconstruct the natural social order of
      the cosmos or something. That’s ridiculous but that’s what the thump thump
      of my heart would feel like.
    </p>
    <p>Q</p>

    <p>
      And when I think about this I wonder “if this is something that people do,
      then why have I never been in one”. And I have close friends. I establish
      very meaningful relationships with other people. I’m not being bragocious
      or anything but I won’t lie and say I’m anti-social and have no important
      people. I’m not going to undermine my self-worth and pretend like I don’t
      have any close relationships.
    </p>
    <p>Q</p>
    <p>
      Another potential problem would be leaving people out. If it were to be a
      group of 11 then how would that person who would have been number 12 feel
      if they ever found out? Heartbroken I’m sure. And that too gives me
      massive anxiety.
    </p>
    <p>Q</p>
    <p>So, I conclude that no one does this. Or at least no one I know.</p>
    <p>Q</p>
    <p>
      Which is weird, because people should be doing it. Or maybe it’s weird
      that people aren’t doing it, whether they should or not.
    </p>
    <p>Q</p>
    <p>I don’t understand why though.</p>
    <p>Q</p>
    <p>
      Yes. And I should have studied sociology because then maybe I can have the
      answer to why don’t people interact when they easily could. Here’s an
      example, just one, just throwing it out there. Since I moved into New York
      I’ve been getting along super well with this cool girl I met named Emily.
      And I always tell her that she reminds me of my other friend from college
      Katie who is now living in San Francisco. I always tell stories about them
      to one another. And I’m sure they will meet eventually, but Katie hasn’t
      visited me in New York yet and I haven’t been to the West Coast in years.
      And it’s nice I can talk to Katie whenever I want to. But there is nothing
      from stopping me besides own inhibitions from creating a fun little group
      between the three of us this instant.
    </p>
    <p>Q</p>
    <p>
      It is always better to meet someone in person, I agree. But why hesitate?
      Why put off connection? It makes me sad. Not sad sad, but sad.
    </p>
    <p>Q</p>
    <p>I think I might just do it. See what happens.</p>
    <p>Q</p>
    <p>Maybe.</p>
  </>,

  <>
    <p>Interview #4</p>

    <p>Q</p>
    <p>
      Man, Thanks. I’m sure you have heard a lot of interesting theories and
      ideas in this process and I would love to hear them after this interview.
    </p>
    <p>Q -</p>
    <p>
      Ok, Ok, I’ll wait for the book. But let me tell you this. None of them are
      nothing compared to this one.
    </p>
    <p>Q -</p>
    <p>
      The entirety of human history is based on the global lie I am about to
      tell you. I’ve talked to a myriad of scholars and they backed me up. But
      the government keeps me silent. They stole loads of things out of my
      office. It’s scary but I have the truth man, I know the truth.
    </p>
    <p>Q -</p>
    <p>What do you know about the resurrection?</p>
    <p>Q -</p>
    <p>The resurrection man. You know. Jesus.</p>
    <p>Q -</p>
    <p>
      Yup, just what I thought. They teach you he died and came back the third
      day. Where did you hear this? Mass media? The bible? All lies man, all
      lies. Jesus wasn’t a god, he was just a man, man. In fact, he was two men.
    </p>
    <p>Q -</p>
    <p>
      Yeah you heard me right, the mainstream media tells you Jesus was a
      singular dude. He was a holy prophet. All lies.
    </p>
    <p>Q -</p>
    <p>
      Well first off: Jesus was a swindler. He wanted fame. Not necessarily
      money, not necessarily power. But fame was important to him. Basically he,
      or they, were magicians.
    </p>
    <p>Q -</p>
    <p>
      I keep saying they because Jesus was actually a they. But let me get to
      that later. Wait... Yes. They were your classic tricksters, your Houdini’s
      or Chris Angels. High profile showmen.
    </p>
    <p>Q -</p>

    <p>
      When you read the bible, each trick, or as Christians like to say
      “miracles”, are actually stunts pulled off by Jesus and their group of
      assistants. And let me tell you this, not all the apostles were in on it.
      Some of them were dopes that the Jesus crew liked to keep around so they
      would spread the news of how Jesus was performing miracles.
    </p>
    <p>Q -</p>
    <p>
      Okay okay I’ll tell you why I keep saying “they” for Jesus. It’s because
      Jesus...were twins.
    </p>
    <p>Q</p>
    <p>
      Yes, identical twins. One of them was often in disguise, dressed as
      another one of the apostles, likely James, but I’m still doing my research
      on that front. They switched roles, played a double life - always. So,
      when they were roaming around both Jesuses would be involved in the magic
      tricks.
    </p>
    <p>Q –</p>
    <p>
      The fish and the bread, making the blind see, walking on water, all
      elaborate heists executed by the Jesuses and his illusion crew. And
      obviously, they pulled it off because there was a book written all about
      their tricks.
    </p>
    <p>Q –</p>
    <p>Things started to get a little bit out of hand.</p>
    <p>Q</p>
    <p>
      Well one of the Jesuses started to be flamboyant in wanting to boost the
      prestige of their show, claiming he was the son of God, he was the
      Messiah. etc. You know the story. And then the following got a little too
      close you know? Started to raise some ears, raise some eyes, be
      suspicious. Especially from the Romans. The Jesuses couldn’t believe it.
      The tricks were getting out of control. A rabid cult following.
    </p>
    <p>Q</p>
    <p>
      I like to think there was a conversation between the two in a candlelit
      room, something like:
    </p>
    <p>
      Jesus 1: Brother, they are after us what are we going to do Jesus 2: Relax
      brother, we must keep up what we are doing, we are the best-known
      magicians in the world. We will have all the fame and glory. Jesus 1:
      That’s not worth it if we are both dead. Jesus 2: We are going to have
      people talking about us for decades. Jesus 1: You are jeopardizing our
      whole career with that son of God talk, we have a good thing going, don’t
      fuck this up. Jesus 2: What do you want me to do? Take it back, how would
      that make us look? Jesus 1: We must figure something out. They will catch
      on and we will both get crucified. We need to have some sort of plan to
      get out of this.
    </p>
    <p>Q –</p>

    <p>
      So, they left Jerusalem and did the whole 40 days in the desert, just the
      two of them. And they came up with a plan on how they would leave the city
      unscathed. It was a fool-proof plan. But they didn’t account for one
      thing.
    </p>
    <p>Q –</p>
    <p>
      Exactly. During the last supper, it was essentially a farewell dinner for
      the heist team. The believers of the apostles thought the bread and wine
      were bread and wine. But what they didn’t account for was that one member
      of their team would betray them.
    </p>
    <p>Q</p>
    <p>
      I don’t know. Maybe Judas wanted to be the main magician in the middle
      east. Maybe it was classic revenge. I have a theory that one of the
      Jesuses (Jesus 2) and Mary Magdalene were lovers and Judas also had a
      thing with MM. AH but yes, maybe I forgot to mention…but the only people
      who knew that the Jesuses were twins was their mother, it was a well-kept
      secret, originally stemming from Mary not wanting to list two children in
      the census of King Herod in fear of both their lives, so she kept them as
      only one child. You see…they grew up pretending to be two different
      people.
    </p>
    <p>Q –</p>
    <p>
      Anyway, Jesus 1 is the unfortunate Jesus that was dressed as the Jesus
      when he got arrested. Jesus 2 (dressed as James) was terrified, his
      brother is going to get killed and it was, mostly, his fault.
    </p>
    <p>Q –</p>
    <p>
      Jesus 1, in his cell, realizes there is no way out of this. But
      fortunately, during the sojourn in the desert, the two brothers discussed
      what would happen if one of them were to be arrested as Jesus and put to
      death. A heist had been planned man.
    </p>
    <p>Q –</p>
    <p>
      Yes, the crucifixion. The reason Jesus stood so tall during this whole
      process was because he knew, in a way, he would live on in his brother,
      the brother he had lived as his whole life, the brother who he shared a
      single life with.
    </p>
    <p>Q</p>
    <p>
      So, Jesus 1 is on the cross, dying. Jesus 2 is scrambling around as
      James…he just saw his twin executed so he is torn apart. He’s terrified.
      But remember Jesus 2 was the more ambitious of the two. He worked with his
      mom and his lover on the scheme, as well as Peter, to whom he revealed his
      true identity. He told Peter the plan, how if Peter played his cards right
      he would have all the power in the heist tea. Obliviously Peter, who was
      the most passionate about the art of magic, was into the plan.
    </p>
    <p>Q</p>
    <p>
      The four of them heisted their way into Jesus 1’s tomb, touched it up so
      it looked like he left from the inside, and then the plan was set into
      motion.
    </p>
    <p>Q</p>
    <p>
      Yes, Jesus 2 now switched out of his James costume and was being full on
      holy Jesus, playing up his whole son of God routine to all the apostles
      and folks who actually thought he was a miracle man. Peter then instructed
      some of these folks to write a book about the event. And there you have
      it.
    </p>
    <p>Q</p>
    <p>
      Oh, right I almost forgot. Jesus 2 and Mary Magdalen then traveled the
      world together, living a life of adventure and love. I’m writing a book on
      that as well.
    </p>
    <p>Q –</p>
    <p>
      Yes, the entirety of Christianity is based on two rogue magicians and a
      lot of people believing their words. It’s an incredible story.
    </p>
    <p>Q</p>
    <p>
      Well I’ve done a couple of things. I’ve made videos and posted them
      online, I do loads of interviews like this, I call churches and tell them
      they are all liars. Most importantly I have been writing a book. What I
      discussed here is only the basics. No bible verses to back me up, and
      trust me there are plenty, none of the in-depth academic work. I’ve only
      talked about the basics. Hell, I’m almost at 600 pages and barely feel
      close to finishing.
    </p>
    <p>Q</p>
    <p>Yes, always love recommendations.</p>
    <p>Q</p>
    <p>No I haven’t seen The Prestige, Why?</p>
  </>,

  <>
    <p>Interview #5 –</p>
    <p>
      Money. Love. Power. Prestige. These are all viewed as rather legitimate
      pursuits in the professional realm, wouldn’t you say?
    </p>
    <p>Q -</p>
    <p>
      Precisely. There are certain ends in our careers. By X time I want to have
      Y things. It’s the same old story. This manifests in wealth, love, etc.
      etc., those lofty ideals you hear about exclusively from your grandfathers
      and old movies. I myself have pursued these matters, and well, was
      successful in such pursuits.
    </p>
    <p>Q -</p>
    <p>
      My quandary is this: why should the objective never be Fun? What is wrong
      with the pursuit of Fun. Not enjoyment or pleasure, no no, those things
      can be manifested by means of money or romance. One never hears Fun as a
      high ideal, does one? Never in my 50 years in the work force have I heard
      Fun be used as one’s purpose for living, their raison d’être. I am talking
      about fun for fun sake. Why so often is Fun discounted as the working
      man’s objective?
    </p>
    <p>Q –</p>
    <p>Do you mind if I smoke?</p>

    <p>Q –</p>
    <p>
      Sure, the system requires people to work for the sake of working. Classic
      economic principle. Wealth guarantees safety, and safety guarantees
      satisfaction. I just ponder: why Fun is so often regarded as frivolous.
      immature. Juvenile.
    </p>
    <p>Q –</p>
    <p>
      Fun is a significant apparatus on how we approach our days. Distinguished
      gentlemen like myself tend to glaze over the reality of Fun. Golfing and
      Boating have an air of prestige to them, but a reductionist approach would
      reduce these activities simply to fun. Hell, hobbies are simply routine
      fun, but no one gaufs at being passionate about a hobby.
    </p>
    <p>Q –</p>
    <p>
      I think, traditionally speaking, fun has a childlike connotation. It is
      the brevity of the word. Honor, wealth, passion all sound lofty when
      leaving the lips. Verbally, fun has no weight.
    </p>
    <p>Q</p>
    <p>
      Perhaps, as a child, it is one of the first emotions of experiences that
      comes from one being. The act of having fun is a legitimate pursuit. It is
      the first act of agency as a child to have fun, to play. Indeed, the
      creation of fun is the only thing a child can in fact control. A child is
      faced with confusion, what is going on in my life, what are these sounds I
      do not understand that my parents are speaking to me, why do some things
      hurt when I touch them? Fun is understood. I am playing and it brings me
      pleasure, it brings me control. Fun makes sense in a world where nothing
      else makes sense. In fact, fun may be the first pursuit in a human’s life
      that is not strictly biological.
    </p>
    <p>Q</p>
    <p>
      And maybe that is why not enough working professionals or high thinkers
      believe fun is a legitimate pursuit of man. Because it is the first end
      one experiences it is regarded as a trivial end, too fundamental, too
      simple to be thought of as more.
    </p>
    <p>Q –</p>
    <p>
      I believe so. And I believe a lot of people like me think there are higher
      ideals out there. But the most basic things in life have great layers of
      complexity. And that should not be overlooked so easily.
    </p>
  </>,

  <>
    <p>Interview #12 -</p>
    <p>
      All expressions are perplexing. But one in particular. Look at the
      expression “To Makes Ends Meet”, it’s a strange one, right? When you think
      about it what exactly comes to mind?
    </p>
    <p>Q</p>
    <p>
      Yeah, it’s doing some dead-end job somewhere just to get buy. Y’know, “to
      make ends meet” so to say.
    </p>
    <p>Q</p>
    <p>
      All expressions come from somewhere, yeah. I’ve looked into it a bit. Not
      too much. Like you don’t see me browsing the library shelves deep into my
      Saturday nights do ya? No, but I did a little bit of research about it.
    </p>
    <p>Q</p>
    <p>
      Why? Well, I don't know, I guess because I was curious about it. People
      say to make ends meet but what ends?
    </p>
    <p>Q</p>
    <p>
      So, there were actually a couple of results in my so called “research”.
    </p>
    <p>Q</p>

    <p>
      Here’s what I remember – the first one is in relationship to sailing. Who
      would’ve figured. Sailing. So many expressions come from sailing – “Clear
      Skies”, “The Coast is Clear”. Who knows why, maybe cuz the sailors were
      all over everywhere. But yeah sailing – making ends meet refers to the
      knot tying of broken ropes or somethin’ like that. I don’t know, I’m not a
      rope man.
    </p>
    <p>Q</p>
    <p>
      Yeah don’t know what that exactly has to do with the whole “having a job
      to get by of it all,” but I digress. Another origin of the phrase is in
      balancing a budget – making the ends of all the finances match up on the
      same line. It had to do with book keeping and I’m no bookkeeper.
    </p>
    <p>Q</p>
    <p>They scribble it down on the bottom. Or something.</p>
    <p>Q</p>
    <p>
      Yeah yeah. This one’s relatable for sure. When you are making ends meet
      you are on a budget right. You are getting the food in your stomach. When
      you “make ends meet” you’re just getting by. You don’t have a gut like
      this one here. Eating is life. So, some people think it might relate to
      getting one end of your belt to the other end, around your stomach. You
      are just getting by, so aren’t starved, you are still able to put that
      belt around your waist. You are making the ends meet.
    </p>
    <p>Q</p>
    <p>
      It works on a couple of levels. Level one: the whole stomach food thing I
      just talked about. But the second one is that when you work you put a belt
      on. So, when you are in the process “of making ends meet” you gotta put
      that belt on and make ends meet, ya know what I’m sayin’? So, I think it
      works to a certain extent.
    </p>
    <p>Q</p>
    <p>No.</p>
    <p>Q</p>
    <p>
      Yeah what “research” has told me is nothin’. This doesn’t make sense.
      Specially sailing. I think my version is a bit more true than those.
    </p>
    <p>Q</p>
    <p>
      Well here it is. Getting by, right? Making Ends meet? Survival. Living
      another god damn day. It’s what you do to ensure you survive. So, what I’m
      thinkin’ is that it’s the ends of your life – your birth and your death.
    </p>
    <p>Q</p>
    <p>
      It is deep! And that’s the point. Expressions all have some deepness to
      them that’s why they stick. But it works in a whole couple of ways. Look
      you got your two ends your birth, your death, and what you do, your job or
      what have you, is what one does in the meantime, that awkward period of
      life.
    </p>
    <p>Q</p>
    <p>
      All of it. So, it’s the whole work/life equation, getting by, working to
      survive, that is how you make the two ends meet.
    </p>
    <p>Q</p>
    <p>
      Now, when somebody says to me “You know, I’m just making ends meet here”,
      I think, yeah you are, you are filling that time, you are living your
      life.
    </p>
    <p>Q</p>
    <p>
      I find this a bit more profound than the whole belt buckle or bookkeeping
      situation. Definitely more than sailing, I’ll tell you that.
    </p>
  </>,

  <>
    <p>Interview #13-</p>
    <p>Q</p>
    <p>Thank you, you are truly a kind sir.</p>
    <p>Q</p>

    <p>
      Right, so my name is [censored], and I’m just a man who loves life. Fresh
      air. Living. There’s a lot to do. And I’m all about having a good time.
    </p>

    <p>Q</p>

    <p>So, my disposition absolutely affect my philosophy. My art even.</p>
    <p>Q</p>

    <p>
      I am an artist, but that’s probably where my controversy comes into play.
      Because what the world thinks of art and what I think of art are, uh, a
      bit different.
    </p>
    <p>Q</p>
    <p>
      The world thinks of art…well first off this isn’t true artists. Like
      artists who know the know. I’m talking the world that goes to a museum for
      45 minutes to score that selfie with the hottest painting in the place.
      The world thinks of art simply in the term of creating. Like, to be an
      artist I have to carve marble or make pots or something.
    </p>
    <p>Q</p>
    <p>I make an art of consuming.</p>
    <p>Q</p>
    <p>
      Yeah…I make art of enjoyment. I’m not saying I’m a hedonist but I would
      likely be classified by one those selfie taking museum goers.
    </p>
    <p>Q</p>
    <p>
      Here’s what I think: there is an art form to enjoying yourself, there is
      art in consuming and knowing what you are consuming. Beauty in consumption
    </p>
    <p>Q</p>
    <p>Well I think there is a stigma attached to this mindset</p>
    <p>Q</p>
    <p>
      Again, it goes back to art equaling creation. Not creativity, because
      consumption can be very creative.
    </p>
    <p>Q</p>

    <p>
      Example…hmmm..let me think. Well the past couple of weeks I got really
      into cheese. Like good cheese. Blue cheeses mainly. The smelly stuff.
    </p>
    <p>Q</p>
    <p>
      Cheese is beautiful – but the art is the knowing how and when and why to
      eat it. People just eating sliced American cheese, I won’t have that.
      That’s scallywag material.
    </p>
    <p>Q</p>
    <p>
      I buy high quality cheeses, I eat it with respect. Fully savoring the
      flavor, enjoying every little note present in the food. There is beauty in
      properly made food; made with love. Cheese makers put their lives into
      their art. Because cheese is just as creative an art as a painting. And my
      art is knowing how to consume this art.
    </p>
    <p>Q</p>
    <p>
      If we are being reductionist about it, it comes down to awareness.
      Consumption sans awareness is what? Cowardice? Ignorance? Consumption with
      awareness and deep understandings of what is being consumed, now that is
      art my friend.
    </p>
    <p>Q</p>
    <p>And my art isn’t just eating or drinking.</p>
    <p>Q</p>
    <p>
      Besides Cheese? Beer, pickles, bread, pot. I want to get really into
      mushrooms. My tastes may seem “manly”, stereotypically. Whatever. Have you
      ever had a really good pickle? Nothing beats a perfect pickle.
    </p>
    <p>Q</p>
    <p>
      No, It’s not about the “what” per se. Any talented shopper can master that
      “what”. Being a true artist in consumption means mastering the other W’s.
      Including how.
    </p>
    <p>Q</p>
    <p>
      Where do you drink beer? Which location? With whom? All the details add up
      to make experiences. Mastering these elements. Knowing when to consume
      stout over lager, how will certain elements make you feel and how do you
      best perfect the consumption.
    </p>
    <p>Q</p>
    <p>
      I would say consumption, like real artful consumption, can just be thought
      about the “art” of living. A deep knowledge of what to do and when.
    </p>
    <p>Q</p>
    <p>Go on.</p>
    <p>Q</p>

    <p>
      Yeah no, there’s a balance to it as well. I’m not advocating endless
      consumption, stuffing yourself. The absence of consumption is just as good
      as consumption. It’s being mindful, intentional.
    </p>
    <p>Q</p>
    <p>
      But I’m also saying being reserved is the goal either. Getting drunk is
      great. I love over-drinking. My goal, my aspiration, is to make
      transcendental art out of being absolutely sloshed.
    </p>
    <p>Q</p>
    <p>
      No? People go into a bar, into a night out, so mindlessly. So,
      animal-like. They think, “drink, get drunk, get laid:. And yes, those are
      all great things. But people do it so poorly and improperly. Without any
      proper intention.
    </p>
    <p>Q</p>
    <p>
      It’s about knowing what to drink, to what volume, when to take shots,
      making sure your companions are worthwhile conversationalists. Embracing
      the hangover, or reducing it. Pickles help.
    </p>
    <p>Q</p>
    <p>I would say I have mastered this.</p>
    <p>Q</p>
    <p>
      But I fill like you are misunderstanding me. My Art is everything. It’s
      living. It’s enjoying. I think you think I go about all this on a whim but
      no. I am passionate about living, I don’t think there is any shame is
      saying “my life goal is to perfect enjoying life”, in fact I think it’s
      the noblest goal of all sir.
    </p>
    <p>Q</p>
    <p>Uh-huh</p>
    <p>Q</p>
    <p>
      Then let’s go out. You and me. And I will show you what my art is all
      about.
    </p>
  </>,

  <>
    <p>Interview #24 –</p>
    <p>
      Look, it’s not like I can just walk into the Doctor’s office or anything
      and tell him what I’m thinking.
    </p>
    <p>Q</p>
    <p>
      You think I should just sit there during the physical, do all the heavy
      breathing and joint checking, stethoscope and etcetera, and then at the
      end, when he asks, ‘do you have any questions or concerns’, I just say,
      ‘well doc, I think I might have Autism’.
    </p>
    <p>Q</p>
    <p>
      No of course I wouldn’t do it like that exactly, but that’s why I’m making
      the joke. Or trying to at least. But the point is that it is in fact a
      very hard thing to ask a doctor about maybe being autistic.
    </p>
    <p>Q</p>
    <p>
      I’ve always been different. You know that. Weird. On the outside of the
      social scene. I mean look at us when we were growing up, I didn’t exactly
      have friends in middle school. I feel like I got lucky in finding a normal
      friend group with you because…
    </p>
    <p>Q</p>
    <p>
      Well yeah, because we were, are in a sense, weirdos. But good weird you
      know. I wouldn’t trade it. But you know what I’m saying; my clothes never
      matched, could barely dress myself, I have infinite cabinet space in my
      brain about Pokémon and Dragonball Z and the Beatles and that to this day
      I remember in great detail. I can remember conversations word for word.
      Obsessed with calendars. I’m great with computers, I mean look it’s my
      career now.
    </p>
    <p>Q</p>

    <p>
      But it’s that I have all the traits of someone on the spectrum. And look
      you know, it’s not like my mom was going to bring me to the doctor. She
      had enough on her plate when I was growing up. It probably never occurred
      to her. I was just a little odd. Maybe if my Dad was there there would be
      some conflicting views but she didn’t think there was anything wrong.
    </p>
    <p>Q</p>
    <p>
      Apparently, it’s harder to diagnose in adults. I don’t know the details or
      anything. It’s harder to pick up I guess, the cues are different, there
      isn’t a proper process in place. Or at least that’s what I read. Maybe if
      I did talk to my doctor there would be some more details on what to do.
    </p>
    <p>Q</p>
    <p>
      And don’t get me wrong, I don’t think that it’s bad to be autistic or
      anything. No, I’m not trying to find something wrong with me.
    </p>
    <p>Q</p>
    <p>What am I looking for?</p>
    <p>Q</p>
    <p>I think, I think it just would be nice to have an explanation.</p>
    <p>Q</p>
    <p>
      As to why I’m the way I am, why I couldn’t talk for the first couple of
      years of my life, why I think in numbers and group things together, why I
      can never tell if that person’s smile is earnest or if it’s out of pity.
    </p>
    <p>Q</p>
    <p>
      It would be so nice, so so so nice, to have an explanation to it all. For
      a doctor to come up to me and to say ‘you are like this because there are
      some chemicals in your brain that make you process things differently’. It
      would be such a relief.
    </p>
    <p>Q</p>
    <p>
      From the constant circus in my inner thoughts of doubt. It would be such a
      relief to know that I have issues interacting with others because of
      something describable rather than it just being me and the cocktail of my
      own unique personality quirks and hiccups.
    </p>
    <p>Q</p>
    <p>Easier to blame it on a word I guess.</p>
    <p>Q</p>
    <p>
      Anyway, I took a Buzzfeed quiz the other day, and it said that I wasn’t
      autistic. But I do think a doctor would be a much more legitimate
      resource.
    </p>
  </>,

  <>
    <p>Interview #25 –</p>
    <p>Q</p>
    <p>
      So, I have felt like this for quite some time now and I really do not know
      who else to turn to.
    </p>
    <p>Q</p>
    <p>Where would you like me to start?</p>
    <p>Q</p>
    <p>
      Well I think I have, in some sense, felt like this more or less my whole
      life. This feeling like I have no control over anything. Like I am just a
      pawn in a great scheme.
    </p>
    <p>Q</p>
    <p>
      If I had to pick a genesis of it all – or at least the branch of this
      particular story, it would be when I first met Eleanor Fitton. And this
      was in college.
    </p>
    <p>Q</p>
    <p>
      This was my Sophomore year, she is one year younger than me. We met at a
      frat party, the particular frat in which I was a member in and she was in
      a particular sorority. The music was bad, but no one seemed to notice. The
      beer was barely beer, more a prop than beer, but still we drank it, and
      eventually our lips touched and then things went on from there. So maybe
      this was not the start either?
    </p>
    <p>Q</p>

    <p>
      Maybe the “start” to these particular set of emotions I am experiencing
      and plots I am involved is then the rushing process – or perhaps the
      bidding. You see, Daniel Weise and Mike Lampsky, Mike-O is what we called
      him, were very eager to have me as a freshman rush Tau Rho Lambda, almost
      like there was something that I did not know, that I was meant to rush
      there, like it was predetermined that I would get a bid.
    </p>
    <p>Q</p>
    <p>
      Yes, now that is the issue is it not? I felt the same way when applying to
      and interviewing for Manson College – it felt easy. Orchestrated. Some
      great They had set it up so things would work out. I guess in using this
      logic then maybe there is no point in finding the true beginning, but
      rather my beginning with Eleanor Fitton.
    </p>
    <p>Q</p>
    <p>
      Frat House and cheap beer. We make out. And things do not stay on the
      dance floor. We do in fact clichély head to my room in Tau Rho. And
      another thing, the sorority she was involved with and the one I was in had
      some secret history of relationship building, some type of mechanical
      attraction. But not like the movies, we do connect. In fact, we did not
      have sex until the third time we were together. But there was some
      particular emotion in play.
    </p>
    <p>Q</p>
    <p>
      See at the time I thought it might have been Love. But the more I reflect
      on my past and these particular first moments with Eleanor Fitton I think
      that Love may be too loose of a term. There is Love between Eleanor and I,
      no doubt. But these first interactions have more of a, um,…
    </p>
    <p>Q</p>
    <p>
      Yes, something like that. It was building block love. With instructions
      written somewhere I could not locate. It was rigid. And now, when I
      imagine Love, or at least the type of love that I want to imagine, is
      something more sporadic, fire-like. Because everything came too easily
      with Eleanor and I – our dates were charismatic and something to write
      home about, our friends all got along. We went on spring break in Mexico.
      She wore a white bikini and this white bucket hat and her blond hair
      overwhelmed me. I was enthralled. Because it was particularly perfect.
    </p>
    <p>Q</p>
    <p>
      So, you know what happens, because in a sense it’s predestined. I
      graduated and get the political consulting job that I wanted, another
      thing that seemed too predetermined to be pure chance. I had a starter
      career in a shit economy and was making good money right out of college. I
      visited Eleanor on the weekends up at Manson – we went to parties in
      college and ate late night drunk pizza and I bought because once again I
      was making good money. And she put her hand on my chest and in one way it
      was endearing, a beautiful belonging, but when I think about this in
      hindsight I feel like it was more of a territory claim than a gesture of
      adoration.
    </p>
    <p>Q</p>
    <p>
      And, again, like clockwork, no hiccups, she graduates and gets a
      management job in DC, through sorority connections nonetheless. And all is
      great – we move in together, a lovely townhouse. All our friends are also
      in DC because they also all had hiccupless interviews, and we are all
      making a lot of money for people just out of college and we go to all the
      classic bars in DC and we travel to Bermuda and Los Angeles.
    </p>
    <p>Q</p>
    <p>
      Proposing was always on the table with Eleanor Fitton. Four years after
      graduating Mason I propose to her while we are with our friends and family
      on the cape and it’s splendid and everyone is so happy and excited for us
      because we are a particularly perfect couple.
    </p>
    <p>Q</p>

    <p>
      And I think, at the Fitton beach house, on a hot summer day while drinking
      a mojito I had the creeping thought “you are not in control of any of
      this”.
    </p>
    <p>Q</p>
    <p>
      No it wasn’t an actual voice external to me. Nor in my head. It was a
      thought. And I’m not sure why but it was actually Mrs. Fitton, the tennis
      player, and the sweater that she wore that made me think this particular
      thought.
    </p>
    <p>Q</p>
    <p>Yes, the sweater.</p>
    <p>Q</p>
    <p>
      She came up to me, you know we were very well acquainted at this point,
      Eleanor and I have been dating for 6 or 7 years. And she knew me too you
      know. Like she knew who I was on a more archaic level. She knew that I
      played lacrosse in high school and that I was a brother of Tau Rho Lambda.
      She knew the makeup of my past and all its intricacies. And her hair is
      tight and she is fit and she has some gorgeous jewelry on that Mr. Fitton,
      or Rodney as he liked me to call him, bought for her, and she’s asking me
      about plans for the wedding planner and she has someone in mind that she
      knows about and I swore I knew the name already and I knew that meeting
      with this wedding planner is what was going to happen. And I don't know
      what it was, but there was something about the white sweater she wore
      while telling me about the cake and the flower arrangements with the red
      wine in her hands that I could not take my eyes off of. The design of the
      wool, it was intricate, and complex, clearly a work of art and hand woven.
      And…and I don’t know but that thought of no control just jumped in right
      then and there.
    </p>
    <p>Q</p>
    <p>
      And she’s talking to me emphatically, and I cannot think of anything but
      this sweater and how it must have been planned from a very early stage how
      every single thread will be knitted. Every step along the way is planned,
      and every thread affects the other threads and their carefully planned
      path, and I suddenly realized that I was not the knitter but the sweater,
      and I was being made to be worn by Eleanor.
    </p>
    <p>Q</p>
    <p>
      Then I notice that all the parents here are wearing sweaters for some
      reason. Sweaters at the summer house. My parents, Mrs. Fitton and Rodney,
      Mike-O’s Parents who, for some reason, are also here, because Mr. Lampsky
      and Rodney know each other form some period of earlier life. Something is
      not right.
    </p>
    <p>Q</p>
    <p>
      I begin to recognize that every single moment in my life has, in some way,
      been controlled by people that are not me. By people who have interest in
      my success because my success is part of a greater series of successes.
    </p>
    <p>Q</p>
    <p>
      My accomplishments seem much less like accomplishments when I was always
      designed to accomplish them. Eleanor and I are in bed together later that
      evening, the first time we are officially in bed together as fiancées to
      one another and I recognize that the engagement is just a series of links
      fitting together, some great puzzle on an endless loop coming together
      once again. And in my mind I begin to construct this whole pattern
      attaching one to one and two to two and I know in my heart that I am
      simply a pawn in all of this, and everyone else seems in on it besides me.
      I was always meant to go to Manson College, I was always meant to rush Tau
      Rho Lambda, I was always meant to make out with Eleanor Fitton on the
      dance floor inebriated with bad beer. In fact, when I think about that
      particular night, I think that everyone on the dance floor that night were
      watching us, shifting to bring us closer to one another so that my hand
      would eventually find itself on her waist and my lips on her lips, the
      respective fraternity and sorority morphing to bring two units together.
      Is this crazy?
    </p>
    <p>Q</p>
    <p>Well, what do you think?</p>
    <p>Q</p>
    <p>You think I am overthinking this?</p>
    <p>Q</p>

    <p>
      See I know where you are coming from there. And I thought about that. Is
      this just my nerves about getting engaged? Or just some type of Imposter
      syndrome at the Summer house? But no. No. It has to be more orchestrated
      than that. Because I swear every single time I try to deviate from this
      plan that I am not privy to, the particular plan Eleanor Fitton knows by
      heart, something stops me.
    </p>
    <p>Q</p>
    <p>
      I wanted to study abroad my Junior year – go to Europe or something. And I
      know that if I had done that, then maybe I would not have continued things
      with Eleanor. The pull of the illusionary other. One more semester apart.
      But for some reason – the political science department incorporated a new
      course into the curriculum for that Fall that I had to take or could not
      be a graduate on time.
    </p>
    <p>Q</p>
    <p>
      I know I know it sounds crazy, but there are always things like that. I
      had this friend in high school, friend isn’t the word, but we got along
      and were basically just in different groups, and his band was in DC, he is
      a bassist, and he wanted me to stop by and check them out and I was so for
      it, but the evening when there was the gig Eleanor got into a minor
      accident and I needed to bring her to the emergency room to wait for the
      buckle fracture.
    </p>
    <p>Q</p>
    <p>But there are always things like that!</p>
    <p>Q</p>
    <p>
      No it’s not that I feel like I am being used. I think that in every
      relationship there is some sense of using going on – whether it be to help
      the other grow, or for comfort or for support. There is good using, good
      mutual using of another. And I think that that does exist between Eleanor
      and me. But it’s more the fact that I do not have control, and that every
      single action or decision seems to be on some pre-set track that makes me
      so anxious all the time.
    </p>
    <p>Q</p>
    <p>I do appreciate this, thank you so much.</p>
    <p>Q</p>
    <p>Hmm.</p>
    <p>Q</p>
    <p>
      Well when you put it like that, I can see where you, theoretically, are
      coming from. But do you not think that it’s possible that I am just the
      subject of something much larger than me and my personal choices?
    </p>
    <p>Q</p>
    <p>Yes.</p>
    <p>Q</p>
    <p>Yes.</p>
    <p>Q</p>
    <p>So what do you suggest?</p>
    <p>Q</p>
    <p>For how long?</p>
    <p>Q</p>
    <p>And that will work?</p>
    <p>Q</p>
    <p>I think so but, how can we be sure.</p>
    <p>Q</p>
    <p>Yes.</p>
    <p>Q</p>
    <p>Yes. And I do believe that…wait can you say that again?</p>
    <p>Q</p>
    <p>…</p>
    <p>Q</p>
    <p>Are you a part of this?</p>
    <p>Q</p>
    <p>No. I’m serious. Are you a part of this?</p>
    <p>Q</p>
    <p>
      My brother recommended me to you, and he, and he was recommended to you by
      someone else…and…and… Eleanor doesn’t know I’m here but…but if you are
      trying to dissuade me…to return to how I have been thinking for all these
      years….then I will be going back to Eleanor. And….
    </p>
    <p>Q</p>
    <p>No.</p>
    <p>Q</p>
    <p>I am going to leave. You are a part of this and I am going to leave.</p>
    <p>Q</p>
    <p>..</p>
  </>,

  <>
    <p>Interview # 26 –</p>
    <p>Listen Autumn child, and hear the truth in what I say.</p>
    <p>Q</p>
    <p>
      As is the center of the universe, as the wheel of samsara moves through
      the cosmos, every you will already encounter has already crossed your
      path.
    </p>
    <p>Q</p>
    <p>You have already met everyone you will ever meet.</p>
    <p>Q</p>
    <p>
      Time is circular, circles in circles, points converging at different
      moments. But as you know, it is not the points in time, but the people in
      time.
    </p>
    <p>Q</p>
    <p>
      There are 432 people in your life, and they rise and sink like the waves,
      manifesting with different faces in different phases. Is not the moon the
      same moon each evening, but does it not wear the face of a stranger?
    </p>
    <p>Q</p>
    <p>
      Every person you have already met, every person you know concurrently, and
      every person you will meet are one of 432. Souls rotating as actors on the
      stage of your waking life.
    </p>
    <p>Q</p>
    <p>
      No, death is not the absolution. People can depart in more way than one.
      Does the swan not depart the lake but leave the feather behind my dear
      summer soul? As in time, as in memory, as in truth, and as in being, the
      life of others exists in a wave.
    </p>
    <p>Q</p>
    <p>
      Your friend in your childhood could become your boss in your first job,
      your partner the cute barista from your college, the doctor on your death
      bed the doctor who bore you. The stranger on the side of the road the man
      who saves your life. We can never know the details of this, but it is the
      truth. Star are constantly burning with a new face, yet the star remains
      the same, does it not.
    </p>
    <p>Q</p>
    <p>
      The skies of our lives have 432 stars, at each point in our lives the
      stars have their own unique faces, with their own stories and pasts, but
      in the end, and at the center, it is the same fire that burns within.
    </p>
    <p>Q</p>
    <p>
      And recognize this too young couchette, that while you look out at the 432
      other stars….your own face changes in its own way. Our souls are in fact
      our own, but we are many. And the questions we ask have been asked
      thousands of times before. Perhaps, in some way, I am you, and you are I,
      and I am talking to the face which I have already become?
    </p>
    <p>Q</p>
    <p>In the end, simply, I do not know.</p>
  </>
];

export default interviewsArray;